import React, { useState, useEffect } from 'react';

const PaginationTypeSwitcher = ({ displayMode, setDisplayMode }) => {

    // useEffect(() => {
    //     // Load saved pagination type from localStorage
    //     const savedPaginationType = localStorage.getItem('paginationType') || 'pages';
    //     setPaginationType(savedPaginationType);

    // }, [setPaginationType]);

    // const handlePaginationTypeChange = (type) => {
    //     setPaginationType(type);
    //     localStorage.setItem('paginationType', type);
    // };

    return (
        <div className="pagination-type-switcher">
            <label htmlFor="displayType">عرض: </label>
            <select
                id="displayType"
                value={displayMode}
                onChange={(e) => setDisplayMode(e.target.value)}
            >
                <option value="page">الصفحات</option>
                <option value="surah">السور</option>
                <option value="favorite">المفضلة</option>
            </select>
        </div>
    );
};

export default PaginationTypeSwitcher;